import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'AIAssistantAttendanceStartCTA',
  props: {
  onClick: {
    type: Function,
    default: null,
  },
  visible: {
    type: Boolean,
    default: true,
  },
  targetSelector: {
    type: String,
    default: undefined,
  },
  buttonText: {
    type: String,
    default: "Iniciar com Anotador de IA",
  },
},
  emits: ["click"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

function handleClick() {
  // Ensure we only open Noa, never close it
  const noaModal =
    document.querySelector("[data-noa-modal]") ||
    document.querySelector(".noa-modal") ||
    document.querySelector('[data-testid="noa-modal"]') ||
    document.querySelector(".ai-assistant-modal");

  const isNoaOpen =
    noaModal?.getAttribute("data-open") === "true" ||
    noaModal?.classList.contains("open") ||
    noaModal?.classList.contains("show") ||
    (noaModal as HTMLElement)?.style.display === "block" ||
    (noaModal as HTMLElement)?.style.visibility === "visible";

  // If Noa is already open, don't proceed with the click to avoid closing it
  if (isNoaOpen) {
    return;
  }

  // Click the target button if it exists
  if (props.targetSelector) {
    const targetBtn = document.querySelector(props.targetSelector) as HTMLElement;
    if (targetBtn) {
      if (typeof (targetBtn as any).onclick === "function") {
        (targetBtn as any).onclick.call(targetBtn);
      } else {
        targetBtn.dispatchEvent(new MouseEvent("click", { bubbles: true }));
      }
    }
  }

  // Call the onClick prop if provided
  if (props.onClick) {
    props.onClick();
  }

  emit("click");
}

return (_ctx: any,_cache: any) => {
  const _component_w_button = _resolveComponent("w-button")!

  return (__props.visible)
    ? (_openBlock(), _createBlock(_component_w_button, {
        key: 0,
        class: "noa-feegow-pms-btn",
        label: __props.buttonText,
        "leading-icon": "smart",
        variant: "secondary",
        block: "",
        onClick: handleClick
      }, null, 8, ["label"]))
    : _createCommentVNode("", true)
}
}

})